

export default {
name: 'userAgreement',
components: {

},
data () {
return {

}
},
methods: {

},
created () {

},
mounted() {

},
}



// WEBPACK FOOTER //
// ./src/views/userAgreement/script.js